import getConfig from 'next/config';

import { BFF_API_ROUTES } from 'constants/apiRoutes';

export const buildDownloadDocumentUrl = (mplFilePath: string, file?: string) => {
  const { publicRuntimeConfig } = getConfig() || {};
  const apiPrefix: string = publicRuntimeConfig?.apiPrefix || '';

  const normalizedPrefix = (apiPrefix || '').replace(/\/$/, '');
  const route = BFF_API_ROUTES.downloadDocument.replace(/^\//, '');

  const base = `${normalizedPrefix}/${route}`;
  const filename = file ? `&filename=${encodeURIComponent(file)}` : '';

  return `${base}?path=${encodeURIComponent(mplFilePath)}${filename}`;
};
